'use client'

import * as React from 'react'

export type KanbanItemPreviewMeta = {
  domRect?: DOMRect
}

export type KanbanItemPreviewHandlers = {
  onLabelClick: (itemId: string, meta?: KanbanItemPreviewMeta) => void
  onLabelDoubleClick: (itemId: string) => void
}

export const KanbanItemPreviewContext =
  React.createContext<KanbanItemPreviewHandlers | null>(null)
